<template>
  <el-dialog
    v-if="dialogVisible"
    :title="rowData.type == 1 ? '审批' : '驳回'"
    :visible.sync="dialogVisible"
    width="30%"
    :before-close="cancelHandler"
  >
    <div class="container">
      <el-form :model="formData" :rules="rulesForm" ref="ruleForm" label-width="100px">
        <el-form-item :label="rowData.type == 1 ? '审批意见' : '驳回原因'" prop="approvalComment">
          <el-input type="textarea" v-model="formData.approvalComment"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="btn-group">
      <el-button @click="confirmHandler">{{ rowData.type == 1 ? '提交审批' : '驳回' }}</el-button>
      <el-button @click="cancelHandler" type="primary">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import superviseContractApi from '@/api/park/superviseContract';
  export default {
    name: 'ApprovalDialog',
    data() {
      return {
        dialogVisible: false,
        formData: {
          approvalComment: '',
        },
        rulesForm: {
          approvalComment: [
            { required: true, message: '审批意见不能为空', trigger: ['change', 'blur'] },
            { min: 0, max: 256, message: '长度在 0 到 256 个字符', trigger: 'blur' },
          ],
        },
        rowData: {},
      };
    },
    methods: {
      openDialog(rowData = {}) {
        console.log(rowData, '行信息');
        this.rowData = rowData;
        this.dialogVisible = true;
      },
      cancelHandler() {
        this.dialogVisible = false;
      },

      confirmHandler() {
        // 通过原因
        this.$refs.ruleForm.validate(async (valid) => {
          if (valid) {
            const postData = {
              applovalResult: this.rowData.type == 1 ? '01' : '02',
              approvalComment: this.formData.approvalComment,
              approvalContractType: '01',
              id: this.rowData.id,
              approvalDataNo: this.rowData.contractNo,
              approvalDepartmentName: this.userInfo.departmentName,
              approvalDepartmentNo: this.userInfo.departmentCode,
              approvalPersonName: this.userInfo.personName,
              approvalPersonNo: this.userInfo.personNo,
              companyCode: this.rowData.companyCode,
              companyName: this.rowData.companyName,
              departmentName: this.rowData.departmentName,
            };
            const { data } = await this.$axios.post(
              superviseContractApi.APPROVAL_SUPERVISE_CONTRACT,
              postData
            );
            if (data.code == 0) {
              this.$message.success(this.rowData.type == 1 ? data.msg : '驳回成功');
              this.cancelHandler();
              this.$emit('refreshTable');
            } else {
              this.$message.error(this.rowData.type == 1 ? data.msg : '驳回失败');
            }
          } else {
            this.$message.error('请补充资料');
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .container {
    text-align: center;
  }
  .btn-group {
    display: flex;
    flex-direction: row;
    justify-content: center;
    margin-top: 30px;
  }
</style>
